var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34913 9.08829C5.23829 9.08829 5.12746 9.04746 5.03996 8.95996C4.87079 8.79079 4.87079 8.51079 5.03996 8.34163L8.34163 5.03996C8.51079 4.87079 8.79079 4.87079 8.95996 5.03996C9.12913 5.20913 9.12913 5.48913 8.95996 5.65829L5.65829 8.95996C5.57663 9.04746 5.45996 9.08829 5.34913 9.08829Z",
    fill: "#F04438"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65079 9.08829C8.53996 9.08829 8.42913 9.04746 8.34163 8.95996L5.03996 5.65829C4.87079 5.48913 4.87079 5.20913 5.03996 5.03996C5.20913 4.87079 5.48913 4.87079 5.65829 5.03996L8.95996 8.34163C9.12913 8.51079 9.12913 8.79079 8.95996 8.95996C8.87246 9.04746 8.76163 9.08829 8.65079 9.08829Z",
    fill: "#F04438"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75033 13.2712H5.25033C2.08283 13.2712 0.729492 11.9178 0.729492 8.75033V5.25033C0.729492 2.08283 2.08283 0.729492 5.25033 0.729492H8.75033C11.9178 0.729492 13.2712 2.08283 13.2712 5.25033V8.75033C13.2712 11.9178 11.9178 13.2712 8.75033 13.2712ZM5.25033 1.60449C2.56116 1.60449 1.60449 2.56116 1.60449 5.25033V8.75033C1.60449 11.4395 2.56116 12.3962 5.25033 12.3962H8.75033C11.4395 12.3962 12.3962 11.4395 12.3962 8.75033V5.25033C12.3962 2.56116 11.4395 1.60449 8.75033 1.60449H5.25033Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBox);
export default __webpack_public_path__ + "static/media/close-box.064c0217a3cde3ecb19493f77585bbf4.svg";
export { ForwardRef as ReactComponent };